import { useSelector, useDispatch } from "react-redux";
import { triggerDataSelector, setTriggerData } from "../services/redux/slices/authSlice";

/**
 * Custom hook for managing triggerData from Redux store
 * 
 * @returns {Object} An object containing:
 *   - triggerData: The current triggerData value from Redux store
 *   - isTriggerDataEmpty: Boolean indicating if triggerData is empty or null
 *   - setTriggerData: Function to update triggerData in Redux store
 */
export const useTriggerData = () => {
  const dispatch = useDispatch();
  const triggerData = useSelector(triggerDataSelector);

  /**
   * Checks if triggerData is empty
   * @returns {boolean} true if triggerData is null, undefined, or an empty object
   */
  const isTriggerDataEmpty = (): boolean => {
    return (
      !triggerData ||
      (typeof triggerData === "object" && Object.keys(triggerData).length === 0)
    );
  };

  /**
   * Updates triggerData in Redux store
   * @param {any} data - The data to set as triggerData
   */
  const updateTriggerData = (data: any) => {
    dispatch(setTriggerData(data));
  };

  return {
    triggerData,
    isTriggerDataEmpty: isTriggerDataEmpty(),
    setTriggerData: updateTriggerData,
  };
};

